import React from 'react'
import Button from '@/components/Button'
import type { SDUIComponentProps } from '@/types/sduiTypes'

/**
 * SDUI Button adapter — wraps the existing Button component
 * to conform to the SDUI component contract.
 */
const SDUIButton: React.FC<SDUIComponentProps> = ({
    id,
    label,
    isLoading,
    disabled,
    variant,
    color,
    size,
    block,
    onClick,
}) => {
    return (
        <Button
            id={id}
            loading={isLoading}
            disabled={disabled}
            variant={(variant as 'solid' | 'twoTone' | 'plain' | 'default') || 'solid'}
            color={(color as string) || undefined}
            size={(size as 'lg' | 'md' | 'sm' | 'xs') || undefined}
            block={(block as boolean) || false}
            onClick={onClick}
        >
            {label}
        </Button>
    )
}

SDUIButton.displayName = 'SDUIButton'

export default SDUIButton
